
export default function WhyPaced() {
  return (
    <section className="py-24 bg-[#F9F8F6]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-8 font-serif">
              Why PACED Coaching?
            </h2>

            <div className="mb-8">
              <p className="text-lg text-gray-600 mb-4">Most runners either:</p>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-close-circle-line text-2xl text-red-500"></i>
                  </div>
                  <p className="text-lg text-gray-700">Train too hard and get injured</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-close-circle-line text-2xl text-red-500"></i>
                  </div>
                  <p className="text-lg text-gray-700">Or don't train hard enough to improve</p>
                </div>
              </div>
            </div>

            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              PACED Coaching focuses on <strong>smart progression</strong>, <strong>proper recovery</strong>, and <strong>long-term improvement</strong>.
            </p>

            <div className="mb-4">
              <p className="text-lg font-semibold text-gray-900 mb-4">You'll train:</p>
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className="ri-checkbox-circle-fill text-2xl text-[#E8744F]"></i>
                  </div>
                  <p className="text-lg font-semibold text-gray-900">Smarter</p>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className="ri-checkbox-circle-fill text-2xl text-[#E8744F]"></i>
                  </div>
                  <p className="text-lg font-semibold text-gray-900">More consistently</p>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className="ri-checkbox-circle-fill text-2xl text-[#E8744F]"></i>
                  </div>
                  <p className="text-lg font-semibold text-gray-900">With a plan designed specifically for you</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <img
              src="https://static.readdy.ai/image/5e5e0a5518213db53ed2e7d68521f761/96c17c632a07c356ed3e452de8c69811.jpeg"
              alt="Coaching session"
              className="w-full h-auto rounded-3xl shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
